import { Box, styled, Typography } from '@mui/material';

import { TypographyWithOverflowHint } from '../TypographyWithOverflowHint';
import { TimeTablingColorPreset } from './types';

export const ItemRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colorConfig' && prop !== 'withPadding',
})<{ colorConfig?: TimeTablingColorPreset; withPadding?: boolean }>(
  ({ theme, colorConfig, withPadding }) => ({
    '--schedule-text-color': colorConfig?.text,
    '--schedule-text-secondary': colorConfig?.textSecondary,
    '--schedule-text-hover': colorConfig?.textHover,
    borderRadius: theme.shape.borderRadiusSm,
    backgroundColor: colorConfig?.bg,
    overflow: 'hidden',
    cursor: 'pointer',
    height: '100%',
    ...(withPadding && {
      padding: theme.spacing(0.5, 0.5),
    }),
    '&:hover': {
      backgroundColor: colorConfig?.bgHover,
      zIndex: theme.zIndex.drawer,
      '--schedule-text-color': colorConfig?.textHover,
      '--schedule-text-secondary': colorConfig?.textHover,
    },
  }),
);

export const ItemTime = styled(Typography)(() => ({
  color: 'var(--schedule-text-secondary)',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  variant: 'caption',
  lineHeight: 1.2,
  margin: 0,
}));

export const ItemTitle = styled(TypographyWithOverflowHint)<{ onClick?: () => void }>(
  ({ onClick }) => ({
    color: 'var(--schedule-text-color)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(onClick && {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    }),
    lineHeight: 1.2,
  }),
);

export const ItemLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<{ clickable?: boolean }>(({ clickable }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  color: 'var(--schedule-text-color)',
  lineHeight: 1.2,
  ...(clickable && {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  }),
}));
